exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-1Vatr{margin-bottom:20px}.inputContainer-2pAED{margin-bottom:0}.message-9kU49{margin-top:4px;font-size:.9rem;text-align:right;padding:0 20px;-webkit-transition:color .1s;transition:color .1s}.message-9kU49.active-2krxt{color:#eb0a26}.theme-dark .message-9kU49{color:#fff}.theme-dark .message-9kU49.active-2krxt{color:#eb0a26}.theme-light .message-9kU49{color:#212121}.theme-light .message-9kU49.active-2krxt{color:#eb0a26}", ""]);

// exports
exports.locals = {
	"container": "container-1Vatr",
	"inputContainer": "inputContainer-2pAED",
	"message": "message-9kU49",
	"active": "active-2krxt"
};